import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { t } from "@/lib/translations";
import { resolveImg } from "@/lib/api";
import { Reveal } from "./Reveal";

export const About = ({ content }) => {
  const { lang } = useLang();
  const story = content.story || [];

  return (
    <section id="story" className="relative z-10 bg-[#0A0A0A] py-24 md:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-14 items-start">
        <div>
          <Reveal>
            <span className="text-xs tracking-[0.25em] uppercase font-bold text-[#FF5A00]">{t("story_kicker", lang)}</span>
            <p className="font-accent text-4xl md:text-5xl text-[#A8E010] mt-4">
              {lang === "es" ? content.tagline_es : content.tagline_en}
            </p>
            <p className="mt-6 text-lg text-neutral-300 leading-relaxed max-w-lg">
              {lang === "es" ? content.about_es : content.about_en}
            </p>
          </Reveal>

          <div className="mt-12 space-y-px">
            {story.map((ch, i) => (
              <Reveal key={i} delay={i * 0.1}>
                <div className="group flex gap-6 py-6 border-t border-white/10">
                  <span className="font-display text-3xl md:text-4xl text-[#FF5A00]/60 group-hover:text-[#FF5A00] transition-colors">
                    {ch.n}
                  </span>
                  <div>
                    <h3 className="font-display uppercase text-2xl md:text-3xl">
                      {lang === "es" ? ch.title_es : ch.title_en}
                    </h3>
                    <p className="text-neutral-400 mt-1">{lang === "es" ? ch.text_es : ch.text_en}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 1.05 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="relative rounded-3xl overflow-hidden aspect-[4/5] lg:sticky lg:top-28"
        >
          <img src={resolveImg(content.about_image)} alt="story" className="w-full h-full object-cover" style={{ objectPosition: "center 68%" }} />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
          <div className="absolute bottom-6 left-6 right-6 flex items-center justify-between">
            <span className="font-display uppercase text-2xl">{content.business_name}</span>
            <span className="text-xs uppercase tracking-widest text-[#A8E010]">Est. Street</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
